/**
 * The two phase 2 feature flags (featureFlags/global), in a file with no imports so the super-admin flag
 * list (src/lib/featureFlagsRepo.ts) can name them without loading the job markup code.
 * Both are OFF unless set to 'on', and both only ever act on production.
 */
/** Google Indexing API notices (functions/src/googleIndexing.ts). */
export const GOOGLE_INDEXING_FLAG = 'google_indexing_api';
/** The LinkedIn job feed at /feeds/linkedin-jobs.xml (functions/src/linkedInFeed.ts). */
export const LINKEDIN_FEED_FLAG = 'linkedin_jobs_feed';
